import { alpha, styled } from "@mui/material";

export const Container = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => alpha(theme.palette.common.black, 0.5)};
  z-index: 1000;
`;
